import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const ReportingColumnDefaultsModelSchema = z
  .object({
    id: z.string(),
    module_id: z.string(),
    module_key: z.string(),
    reporting_column_type_id: z.string(),
    field_type: z.string(),
    column_title: z.string(),
    field_name: z.string(),
    field_value_ref: z.string().nullish(),
    sort_key: z.string().nullish(),
    filter_key: z.string().nullish(),
    filter_type: z.string().nullish(),
    min_width: z.number(),
    freeze_column: z.boolean(),
    filterable: z.boolean(),
    editable: z.boolean(),
    linkable: z.boolean(),
    link_type: z.string().nullish(),
    link_id_field: z.string().nullish()
  })
  .strict()

const ReportingColumnDefaultsModelFields = makeFieldKeys(ReportingColumnDefaultsModelSchema)

export type ReportingColumnDefaultsModel = z.infer<typeof ReportingColumnDefaultsModelSchema>
